import { render, staticRenderFns } from "./empContract.vue?vue&type=template&id=35678052&scoped=true&"
import script from "./empContract.vue?vue&type=script&lang=js&"
export * from "./empContract.vue?vue&type=script&lang=js&"
import style0 from "./empContract.vue?vue&type=style&index=0&id=35678052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35678052",
  null
  
)

export default component.exports